import { createStyle } from '@gluestack-style/react';

export const AccordionTitleText = createStyle({
  flex: 1,
  textAlign: 'left',
});
